module.exports = __webpack_public_path__ + "static/media/study220628.a34f04ea.png";